import { Breakpoint } from '../../propsValues/breakpoint.mjs';
import { useScreenSize } from '../useScreenSize.mjs';

/**
 * @deprecated Prefer `useScreenSize` instead.
 */
const useLayout = () => {
  const screenXs = useScreenSize(Breakpoint.EXTRA_SMALL);
  const screenSm = useScreenSize(Breakpoint.SMALL);
  const screenMd = useScreenSize(Breakpoint.MEDIUM);
  const screenLg = useScreenSize(Breakpoint.LARGE);
  const screenXl = useScreenSize(Breakpoint.EXTRA_LARGE);
  return {
    isMobile: screenSm != null ? !screenSm : undefined,
    isExtraSmall: screenXs,
    isSmall: screenSm,
    isMedium: screenMd,
    isLarge: screenLg,
    isExtraLarge: screenXl
  };
};

export { useLayout };
//# sourceMappingURL=useLayout.mjs.map
